<template>
  <div class="kechuang">
    <div class="kv">
      <img src="@/assets/family/kechuang/kv.png" alt="" />
    </div>
    <HuaXing
      v-if="colorList.length > 0"
      :info="colorList"
      @next="next"
      :isloading="isloading"
      :showBtn="showBtn"
    ></HuaXing>
    <!-- <img src="@/assets/family/kechuang/1.jpg" alt="" style="width: 100%;" />
    <div class="animation-section">
      <img class="img1 wow" data-wow-duration="2s" src="@/assets/family/kechuang/animate1.png" alt="">
      <img class="img2 wow" data-wow-duration="2s" src="@/assets/family/kechuang/animate2.png" alt="">
    </div> -->
    <div class="container">
      <img class="image" src="@/assets/family/kechuang/0.png" alt=""/>
    </div>
    <!-- <div class="xs-progress">
      <div class="progress-title">人造板甲醛释放量标准</div>
      <div class="progress-list">
        <div v-for="(item, idx) in progress0" :key="idx" class="progress-item">
          <p class="progress-name" :class="{'progress-bottom':idx === 3}" v-html="item"></p>
          <div class="m-progress">
            <div class="m-progress-outer">
              <div class="m-progress-inner" :class="{'p45':idx === 1,'p20': idx === 2,'p4':idx === 3}">
                <div class="u-progress-bg wow"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="xs-progress">
      <div class="progress-title">挥发性有机物释放量( 甲苯、二甲苯为例 )</div>
      <div class="progress-list">
        <div v-for="(item, idx) in progress1" :key="idx" class="progress-item">
          <p class="progress-name" :class="{'progress-bottom':idx === 1}" v-html="item"></p>
          <div class="m-progress">
            <div class="m-progress-outer">
              <div class="m-progress-inner" :class="{'p100-a':idx === 0, 'p1':idx === 1}">
                <div class="u-progress-bg wow"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="xs-progress">
      <div class="progress-title">可溶性重金属含量</div>
      <div class="progress-list">
        <div v-for="(item, idx) in progress2" :key="idx" class="progress-item">
          <p class="progress-name" :class="{'progress-bottom':idx === 1}" v-html="item"></p>
          <div class="m-progress">
            <div class="m-progress-outer">
              <div class="m-progress-inner" :class="{'p100-a':idx === 0, 'p3':idx === 1}">
                <div class="u-progress-bg wow"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="small-tips">
      <p>
        国家标准:GB/T 39600-2021《 人造板及其制品甲醛释放量分级 》
      </p>
      <p>
        绿色标准:GB/T 35601-2017《 绿色产品评价 人造板和木质地板 》
      </p>
      <p>
        检验报告编号2022W0943
      </p>
    </div>
    <img src="@/assets/family/kechuang/3.jpg" alt="" style="width: 100%;" /> -->
  </div>
</template>

<script>
import WOW from '../../../../node_modules/wowjs/dist/wow'
import { getGrainList } from '@/api/product.js'
import HuaXing from '@/components/huaxing.vue'
export default {
  name: 'kechuang',
  components: {
    HuaXing
  },
  data() {
    return {
      isloading: false, // 加载中
      showBtn: true, // 更多
      form: {
        product_id: 1,
        pageNum: 1,
        pageSize: 8
      },
      progress0:['国标E<span>1</span> ≤ 0.124mg/m³','国标E<span>0</span> ≤ 0.050mg/m³','国标E<span>NF</span> ≤ 0.025mg/m³','小森实测 ≤ 0.005mg/m³'],
      progress1:['绿色标准 ≤ 0.02mg/m³','小森实测0.001mg/m³'],
      progress2:['绿色标准 ≤ 100mg/kg','小森实测3.3 mg/kg'],
      colorList: []
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    let wow = new WOW.WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    })
    wow.init()
  },
  methods: {
    getList() {
      this.isloading = true
      getGrainList({
        ...this.form
      }).then(res => {
        if (res.dataList && res.dataList.length > 0) {
          res.dataList.forEach(item => {
            item.mp_logo_pic
              ? (item.mp_logo_pic = JSON.parse(item.mp_logo_pic))
              : []
          })
          this.colorList = [...this.colorList, ...res.dataList]
          if (res.dataList.length >= this.form.pageSize) {
            this.showBtn = true
          } else {
            this.showBtn = false
          }
        } else {
          this.showBtn = false
        }
        this.isloading = false
      })
    },
    next() {
      if (this.isloading) return
      this.form.pageNum++
      this.getList()
    }
  }
}
</script>
<style lang="less" scoped>
p {
  margin: 0;
}

.kechuang {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  .kv {
    width: 100%;
    max-width: 1920px;
    img {
      width: 100%;
      vertical-align: middle;
    }
  }
  .xs-progress {
    text-align: left;
    width: 1538px;
    margin: 0 auto;
    padding: 0 36px;
    border-radius: 10px;
    box-sizing: border-box;
    margin-bottom: 34px;
    .progress-title {
      font-size: 30px;
      color: #745430;
      line-height: 50px;
      margin-bottom: 10px;
      font-weight: 600;
    }
    .xs-progress{
      // height: 598px;
    }
    .progress-item {
      margin-bottom: 10px;
      font-size: 24px;
      color: #745430;
      line-height: 30px;
      display: flex;
      flex-wrap: nowrap;
      flex-direction: row;
      justify-content: flex=start;
    }
    .progress-name {
      width: 400px;
      text-wrap: nowrap;
      /deep/ span {
        margin-top: 2px;
        font-size: 12px;
      }
    }
    .progress-bottom {
      font-size: 24px;
      // color: #251e1c;
      line-height: 30px;
      // font-weight: 600;
    }
  }
  .animation-section {
    width: 100%;
    height: 1148px;
    position: relative;
    .img1 {
      width: 1723px;
      height: 1148px;
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -861.5px;
      z-index: 2;
      animation: first-left 1s forwards;
      opacity: 0;
    }
    .img2 {
      width: 1068px;
      height: 655px;
      position: absolute;
      top: 181.5px;
      left: 84.5px;
      z-index: 3;
      animation: first-left 0.5s forwards;
      animation-delay: 1s;
      opacity: 0;
    }
    @keyframes first-left {
      0% {
        transform: translateX(100px);
        opacity: 0;
      }
      100% {
        transform: translateX(0);
        opacity: 1;
      }
    }
  }
  .small-tips {
    width: 1466px;
    font-size: 15px;
    font-family: FZLanTingHeiS-R-GB;
    font-weight: 400;
    color: #9E9E9F;
    line-height: 21px;
    margin: 0 auto;
    text-align: left;
    padding-bottom: 10px;
  }
}
.container {
  max-width: 1920px;
  margin: 0 auto;
  padding: 60px 220px;
  .image {
    width: 100%;
    vertical-align: top;
    display: block;
  }
}
</style>

<style lang="less" scoped>
.m-progress {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 60px;
  width: 100%;
  .m-progress-outer {
    width: 100%;
    
    .m-progress-inner {
      width: 100%;
      border-radius: 100px;
      .u-progress-bg {
        height: 20px;
        background: linear-gradient(to right, #9b612a, #9b612a);
        animation: width 1.5s forwards;
        @keyframes width {
          0% {
            width: 0%;
          }
          100% {
            width: 100%;
          }
        }
      }
    }
    .p45{
      width: 45%;
      .u-progress-bg{
        background: linear-gradient(to right, #d1892a);
      }
    }
    .p100-a{
      width: 100%;
      .u-progress-bg{
        background: linear-gradient(to right, #E6A637);
      }
    }
    .p20{
      width: 20%;
      .u-progress-bg{
        background: linear-gradient(to right, #edd4ad, #e9cd92);
      }
    }
    .p8{
      width: 8%;
      .u-progress-bg{
        background: linear-gradient(to right, #588d49, #588d49);
      }
    }
    .p3{
      width: 3%;
      .u-progress-bg{
        background: linear-gradient(to right, #588d49, #588d49);
      }
    }
    .p4{
      width: 4%;
      .u-progress-bg{
        background: linear-gradient(to right, #588d49, #588d49);
      }
    }
    .p1{
      width: 1%;
      .u-progress-bg{
        background: linear-gradient(to right, #588d49, #588d49);
      }
    }
  }
  .u-progress-text {
    font-size: 16px;
    line-height: 24px;
    margin-left: 8px;
    color: rgba(0, 0, 0, 0.45);
  }
}
</style>
